// libs
import SplitText from "./_libs/SplitText";
import { QuestionCard } from "./_libs/QuestionCard";
import { SetupArrow } from "./_libs/SetupArrow";
import { JobOpening } from "./_libs/JobOpening";
document.addEventListener("DOMContentLoaded", () => {
  new SplitText(".js-title-target", {
    target: ".js-title-text",
    transition: [80],
  });

  JobOpening();

  QuestionCard();

  SetupArrow();
});

window.addEventListener("load", () => {});
